<div class="risco-zero-banner-container">
    <!-- Assistant Header -->
    <div class="assistant-header">
        <div class="assistant-title-container">
            <div class="head-circuit-icon">
                <img src="assets/icons/head-circuit.svg" alt="Head Circuit Icon" width="21" height="21" />
            </div>
            <span class="assistant-title">Assistente da operação</span>
        </div>
    </div>

    <!-- Frame 2318 - Mensagem de identificação -->
    <div class="identification-frame">
        <p class="identification-message">{{ identificationMessage }}</p>
    </div>

    <!-- Card button - Conteúdo principal -->
    <div class="card-button">
        <div class="content-frame">
            <!-- Frame 1000002677 - Título e descrição -->
            <div class="title-description-frame">
                <h3 class="express-title">{{ expressTitle }}</h3>
                <p class="express-description">
                    {{ expressDescription }}
                </p>
            </div>

            <!-- Frame 1000002676 - Lista de benefícios -->
            <div class="benefits-frame">
                <ng-container *ngFor="let benefit of benefits; let i = index">
                    <div class="benefit-item">
                        <div class="step-success">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <ng-container *ngIf="i < 2">
                                    <path
                                        d="M11.6667 3.5L5.25 9.91667L2.33333 7"
                                        stroke="#004BCC"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </ng-container>
                                <ng-container *ngIf="i === 2">
                                    <!-- Círculo -->
                                    <circle cx="7" cy="7" r="6" stroke="#004BCC" stroke-width="1.5" />
                                    <!-- Linha vertical do ponto de exclamação -->
                                    <path d="M7 3.5V7" stroke="#004BCC" stroke-width="1.5" stroke-linecap="round" />
                                    <!-- Ponto inferior do ponto de exclamação -->
                                    <circle cx="7" cy="9.5" r="0.75" fill="#004BCC" />
                                </ng-container>
                            </svg>
                        </div>
                        <span class="benefit-text">
                            {{ benefit }}
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Button Container -->
        <div class="button-container">
            <button class="express-button" (click)="onFollowExpress()">
                <span>Seguir pelo Express</span>
                <mat-icon>arrow_forward</mat-icon>
            </button>
        </div>
    </div>
</div>
